import { useLocation } from 'react-router-dom';
import { SUPPORTED_LANGUAGE_CODES, type LanguageCode } from '@/data/constants';

export const useLanguageAwareLink = () => {
  const location = useLocation();

  const getLanguagePrefix = (): string => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const firstSegment = pathSegments[0];

    // Check if the first segment is a language code
    if (SUPPORTED_LANGUAGE_CODES.includes(firstSegment as LanguageCode)) {
      return `/${firstSegment}`;
    }

    // Default to no prefix for German (root path)
    return '';
  };

  const createLink = (path: string): string => {
    const languagePrefix = getLanguagePrefix();
    const cleanPath = path.startsWith('/') ? path : `/${path}`;

    // Handle root path navigation - avoid double slashes
    if (cleanPath === '/') {
      return languagePrefix || '/';
    }

    // If the cleanPath already starts with the languagePrefix, don't add it again
    if (languagePrefix && cleanPath.startsWith(languagePrefix + '/')) {
      return cleanPath;
    }

    return `${languagePrefix}${cleanPath}`;
  };

  return { createLink, getLanguagePrefix };
};
